export default __webpack_public_path__ + "static/media/xwhite.3c0afde2.svg";